/**
 * session.store — ที่เก็บ access token **ในหน่วยความจำเท่านั้น**
 *
 * 🚨 **ห้ามเปลี่ยนเป็น `localStorage` / `sessionStorage` / cookie ที่ JS อ่านได้**
 *    access token ใน storage = XSS ตัวเดียวขโมย session ได้ · ตัวที่อยู่ข้ามการรีเฟรช
 *    คือ refresh cookie (httpOnly) ซึ่ง JavaScript แตะไม่ได้ ⇒ รีเฟรชหน้าแล้วเรียก
 *    `POST /auth/refresh` เอา access token ใบใหม่ (นี่คือเหตุผลที่ endpoint นั้นมีอยู่)
 *
 * ⚠️ **ไฟล์นี้ให้แค่ *โรงงาน* ไม่ได้สร้าง instance ไว้** — instance ต้องถูกสร้างที่
 *    composition root ของแอปเท่านั้น (`Workspace-Structure §4`) · lib ที่ export
 *    instance สำเร็จรูป = state ที่ทุกคนแชร์กันโดยไม่มีใครเห็นว่าใครเป็นเจ้าของ
 */
export type SessionStore = {
  get(): string | null;
  set(accessToken: string): void;
  clear(): void;
};

export function createSessionStore(): SessionStore {
  let accessToken: string | null = null;
  return {
    get: () => accessToken,
    set: (token) => {
      accessToken = token;
    },
    clear: () => {
      accessToken = null;
    },
  };
}
